import { productConstants } from '../constants';
import { getListControls } from '../../utils';

export const ProductRemote = (state = {}, action) => {
  switch (action.type) {
    case productConstants.PRODUCTSREMOTE_REQUEST:
      return { loading: true, items: undefined, error: undefined }; //Mostrar gif loader mientras ejecuta request
    case productConstants.PRODUCTSREMOTE_SUCCESS:
      const productDefinition = action.productData?.Body.find((el) => el.Id === 17);
      return {
        loading: false,
        items: action.productData.Body, //Obtener respuesta correcta del API
        productId: productDefinition?.Id,
        // controls: getGenericControls(action.productData.Body[0]),
        controls: getListControls(productDefinition),
        error: undefined,
      };
    case productConstants.PRODUCTSREMOTE_FAILURE:
      return {
        loading: false,
        items: undefined,
        error: action.error, //Mostrar error del API
      };
    default:
      return state; //Retornar state vacío o actual
  }
};
//Siguiente paso => Volver a screens con respuesta
